import type { RouteObject } from 'react-router';
import { RecipeDetailPage } from './RecipeDetailPage';
import { RecipeFormPage } from './RecipeFormPage';
import { RecipeListPage } from './RecipeListPage';
import { RecipeRankingsPage } from './RecipeRankingsPage';

/** Routes for the recipes area (mounted inside RequireHousehold). */
export const recipesRoutes: RouteObject[] = [
  { path: '/recipes', element: <RecipeListPage /> },
  { path: '/recipes/new', element: <RecipeFormPage mode="create" /> },
  { path: '/recipes/rankings', element: <RecipeRankingsPage /> },
  { path: '/recipes/:id', element: <RecipeDetailPage /> },
  { path: '/recipes/:id/edit', element: <RecipeFormPage mode="edit" /> },
];
